// extracted by mini-css-extract-plugin
var _1 = "WSB0VcKdGWjQfOg5Aswj";
var _2 = "meU5J9zlnEZqWlXJJFDW";
export { _1 as "sidebar", _2 as "sidebarSticky" }
